/* eslint-disable camelcase */
export default {
    en: {
        title: 'My jobs',
        subtitle: 'View your active, previous, and rejected job applications',
        subtitle_confirmed: 'View your active and previous job assignments',
        subtitle_applied: 'View your pending job applications',
        subtitle_rejected: 'View your rejected job applications',
        status: {
            applied: {
                title: 'Applied',
                description: 'Awaiting approval'
            },
            confirmed: {
                title: 'Confirmed',
                description: 'Scheduled work'
            },
            externalJob: {
                title: 'Confirmed (Sync)',
                description: 'Jobs synchronized from external systems'
            },
            rejected: {
                title: 'Rejected',
                description: 'Applications that were not approved'
            },
            all: {
                title: 'All',
                description: 'Submitted, confirmed, and rejected applications'
            }
        },
        actions: {
            viewDetails: 'Details'
        },
        empty: {
            confirmed: {
                title: 'No Confirmed Assignments',
                description: 'You don\'t have any confirmed work. Check back soon for new opportunities!'
            },
            externalJob: {
                title: 'No External Assignments',
                description: 'You don\'t have any jobs synchronized from external systems yet.'
            },
            applied: {
                title: 'No Pending Applications',
                description: 'You haven\'t applied to any jobs yet. Browse available offers to get started.'
            },
            rejected: {
                title: 'No Rejected Applications',
                description: 'You don\'t have any rejected applications.'
            },
            all: {
                title: 'No Job Applications',
                description: 'You haven\'t applied to any jobs yet. Browse available offers to get started.'
            }
        },
        errors: {
            loadFailed: 'Failed to load your jobs',
            tryAgain: 'Please try again or contact support if the problem persists',
            unauthorized: 'You must be logged in to view your jobs'
        },
        loading: 'Loading your jobs...',
        loadingMore: 'Loading more jobs...',
        loadMore: 'Load more',
        details: {
            comment: 'You submitted application with note:',
            schedule: 'Schedule',
            youAcceptedAt: 'You accepted {{date}}',
            leaveFeedback: 'Have any questions or feedback? Leave it here'
        }
    },
    no: {
        title: 'Mine jobber',
        subtitle: 'Se dine aktive, tidligere og avviste jobbsøknader',
        subtitle_confirmed: 'Se dine aktive og tidligere jobboppdrag',
        subtitle_applied: 'Se dine ventende jobbsøknader',
        subtitle_rejected: 'Se dine avviste jobbsøknader',
        status: {
            applied: {
                title: 'Søkt',
                description: 'Venter på godkjenning'
            },
            confirmed: {
                title: 'Bekreftet',
                description: 'Planlagt arbeid'
            },
            externalJob: {
                title: 'Bekreftet (Synk)',
                description: 'Jobber synkronisert fra eksterne systemer'
            },
            rejected: {
                title: 'Avvist',
                description: 'Søknader som ikke ble godkjent'
            },
            all: {
                title: 'Alle',
                description: 'Innsendte, bekreftede og avviste søknader'
            }
        },
        sections: {
            currentFuture: 'Nåværende og kommende',
            past: 'Tidligere jobber'
        },
        actions: {
            viewDetails: 'Detaljer'
        },
        empty: {
            confirmed: {
                title: 'Ingen bekreftede oppdrag',
                description: 'Du har ingen bekreftede jobber. Sjekk tilbake snart for nye muligheter!'
            },
            externalJob: {
                title: 'Ingen eksterne oppdrag',
                description: 'Du har ingen jobber synkronisert fra eksterne systemer ennå.'
            },
            applied: {
                title: 'Ingen ventende søknader',
                description: 'Du har ikke søkt på noen jobber ennå. Bla gjennom tilgjengelige tilbud for å komme i gang.'
            },
            rejected: {
                title: 'Ingen avviste søknader',
                description: 'Du har ingen avviste søknader.'
            },
            all: {
                title: 'Ingen jobbsøknader',
                description: 'Du har ikke søkt på noen jobber ennå. Bla gjennom tilgjengelige tilbud for å komme i gang.'
            }
        },
        errors: {
            loadFailed: 'Kunne ikke laste dine jobber',
            tryAgain: 'Vennligst prøv igjen eller kontakt support hvis problemet vedvarer',
            unauthorized: 'Du må være logget inn for å se dine jobber'
        },
        loading: 'Laster dine jobber...',
        loadingMore: 'Laster flere jobber...',
        loadMore: 'Last mer',
        details: {
            comment: 'Du sendte inn søknad med notat:',
            schedule: 'Timeplan',
            youAcceptedAt: 'Du aksepterte {{date}}',
            leaveFeedback: 'Har du spørsmål eller tilbakemeldinger? Legg dem inn her'
        }
    },
    sv: {
        title: 'Mina jobb',
        subtitle: 'Se dina aktiva, tidigare och avvisade jobbsökningar',
        subtitle_confirmed: 'Se dina aktiva och tidigare jobbuppdrag',
        subtitle_applied: 'Se dina väntande jobbsökningar',
        subtitle_rejected: 'Se dina avvisade jobbsökningar',
        status: {
            applied: {
                title: 'Ansökt',
                description: 'Väntar på godkännande'
            },
            confirmed: {
                title: 'Bekräftad',
                description: 'Schemalagt arbete'
            },
            externalJob: {
                title: 'Bekräftad (Synk)',
                description: 'Jobb synkroniserade från externa system'
            },
            rejected: {
                title: 'Avvisad',
                description: 'Ansökningar som inte godkänts'
            },
            all: {
                title: 'Alla',
                description: 'Inlämnade, bekräftade och avvisade ansökningar'
            }
        },
        sections: {
            currentFuture: 'Aktuella och kommande',
            past: 'Tidigare jobb'
        },
        actions: {
            viewDetails: 'Detaljer'
        },
        empty: {
            confirmed: {
                title: 'Inga bekräftade uppdrag',
                description: 'Du har inget bekräftat arbete. Kolla tillbaka snart för nya möjligheter!'
            },
            externalJob: {
                title: 'Inga externa uppdrag',
                description: 'Du har inga jobb synkroniserade från externa system än.'
            },
            applied: {
                title: 'Inga väntande ansökningar',
                description: 'Du har inte ansökt om några jobb än. Bläddra bland tillgängliga erbjudanden för att komma igång.'
            },
            rejected: {
                title: 'Inga avvisade ansökningar',
                description: 'Du har inga avvisade ansökningar.'
            },
            all: {
                title: 'Inga jobbsökningar',
                description: 'Du har inte ansökt om några jobb än. Bläddra bland tillgängliga erbjudanden för att komma igång.'
            }
        },
        errors: {
            loadFailed: 'Kunde inte ladda dina jobb',
            tryAgain: 'Försök igen eller kontakta support om problemet kvarstår',
            unauthorized: 'Du måste vara inloggad för att se dina jobb'
        },
        loading: 'Laddar dina jobb...',
        loadingMore: 'Laddar fler jobb...',
        loadMore: 'Ladda mer',
        details: {
            comment: 'Du skickade in ansökan med anteckning:',
            schedule: 'Schema',
            youAcceptedAt: 'Du accepterade {{date}}',
            leaveFeedback: 'Har du några frågor eller feedback? Lämna det här'
        }
    }
} as const;
